import React from 'react';
import PropTypes from 'prop-types';
import DownloadButton from '../IconButton/DownloadButton';

const DownloadBtn = ({ value, data, columnKey }) => {
  const btnHandler = () => {
    value.onClick(value.id);
  };

  return (
    <DownloadButton onClick={btnHandler} title={data ? data[columnKey] : ''} />
  );
};

DownloadBtn.propTypes = {
  value: PropTypes.object,
  data: PropTypes.object,
  columnKey: PropTypes.string,
};

export default DownloadBtn;
